var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:{bordered: _vm.bordered},style:(_vm.style)},[_c('img',{attrs:{"alt":_vm.alt,"src":_vm.image,"draggable":"false"},on:{"error":_vm.onError}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }